import 'slick-carousel';

if (typeof window.appJs === "undefined") {
    console.error("appJs is not defined");
    window.appJs = {};
}
var resourceBlockFilter = {};

(function (resourceBlockFilterApp, appJsApp) {
    var filterModel = {
        Subject: "",
        FileType: "",
        ResourceIds: ""
    };
    var $CurrentResourceBlockElement = null;
    var $CurrentResourceBlockArticleSliderElement = null;


    resourceBlockFilterApp.GetResources = function () {
        $.ajax({
            url: "/umbraco/surface/ResourceSurface/GetBlockFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                resourceBlockFilterApp.SetCurrentResourceBlockArticleSliderElement();
                resourceBlockFilterApp.ClearArticleSlider();
                $CurrentResourceBlockElement.find(".js-resource-filter-results").first().html(data);
                resourceBlockFilterApp.InitializeArticleSlider();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    resourceBlockFilterApp.InitializeArticleSlider = function () {
        $CurrentResourceBlockArticleSliderElement.each(function () {
            $(this).slick({
                dots: true,
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-left"></use></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-circle-right"></use></svg></button>',
                appendArrows: $(this).parents(".article-slider").find(".arrows-append"),
                appendDots: $(this).parents(".article-slider").find(".dots-append"),
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var direction = "";
                $(this).removeClass("direction-right direction-left");
                if (Math.abs(nextSlide - currentSlide) == 1) {
                    direction = (nextSlide - currentSlide > 0) ? "direction-right" : "direction-left";
                    $(this).addClass(direction);
                } else {
                    direction = (nextSlide - currentSlide > 0) ? "direction-left" : "direction-right";
                    $(this).addClass(direction);
                }
            });
        });
    }

    resourceBlockFilterApp.ClearArticleSlider = function () {
        $CurrentResourceBlockArticleSliderElement.slick('unslick');
        $CurrentResourceBlockElement.find('.article-slider__slide').remove();
    }

    resourceBlockFilterApp.SetCurrentResourceBlockArticleSliderElement = function () {
        $CurrentResourceBlockArticleSliderElement = $CurrentResourceBlockElement.find(".js-article-slider").first();
    }


    $(document).ready(function () {
        $(document).on("submit", ".js-resource-filter-form", function (e) {
            e.preventDefault();
            setCurrentResourceBlockElement(this);
            setSecondaryFitersVisibility();
            populateFilterModel();
            resourceBlockFilterApp.GetResources();
        });

        $(document).on('click', '.js-filter-item', function (e) {
            setCurrentResourceBlockElement(this);
            let buttonText = $(this).text();
            let buttonValue = $(this).val();
            let filterType = $(this).data('type');
            $(this).prop('disabled', true);
            addFilter(buttonText, buttonValue, filterType);
            setSecondaryFitersVisibility();
            populateFilterModel();
            resourceBlockFilterApp.GetResources();
        });

        $(document).on('click', '.js-selected-filter', function (e) {
            setCurrentResourceBlockElement(this);
            $(this).remove();
            let buttonValue = $(this).val();
            $CurrentResourceBlockElement.find(`.js-filter-item[value='${buttonValue}']`).first().prop('disabled', false);
            setSecondaryFitersVisibility();
            populateFilterModel();
            resourceBlockFilterApp.GetResources();
        });

        $(document).on('click', '.js-clear-all-filters', function (e) {
            setCurrentResourceBlockElement(this);
            clearFilters();
            setSecondaryFitersVisibility();
            populateFilterModel();
            resourceBlockFilterApp.GetResources();
        });


        function populateFilterModel() {
            let subjects = [];
            let fileTypes = [];
            let resourceIds = [];

            $CurrentResourceBlockElement.find(".js-selected-filter[data-type='subject']").first().each(function () {
                subjects.push($(this).val())
            });
            $CurrentResourceBlockElement.find(".js-selected-filter[data-type='filetype']").first().each(function () {
                fileTypes.push($(this).val())
            });
            resourceIds = $CurrentResourceBlockElement.find(".js-resource-filter-results").first()?.data('resourceids');

            filterModel.Subject = subjects.join(",");
            filterModel.FileType = fileTypes.join(",");
            filterModel.ResourceIds = resourceIds;
        }

        function setCurrentResourceBlockElement(element) {
            $CurrentResourceBlockElement = $(element).closest('.js-resource-block');
        }

        function clearFilters() {
            $CurrentResourceBlockElement.find('.js-selected-filters').first().empty();
            $CurrentResourceBlockElement.find('.js-filter-item').each(function () {
                $(this).prop('disabled', false);
            });
        }

        function addFilter(buttonText, buttonValue, filterType) {
            let filterMarkup =
                `<button class="button button--outline js-selected-filter" type="button" value="${buttonValue}" name="${buttonValue}" data-type="${filterType}">
                    ${buttonText}
                    <svg class="icon" role="presentation">
                        <use xlink:href="#icon-cross"></use>
                    </svg>
                </button>`;
            $CurrentResourceBlockElement.find('.js-selected-filters').first().append(filterMarkup);
        }

        function setSecondaryFitersVisibility() {
            var currentSelctedFitersElement = $CurrentResourceBlockElement.find('.js-secondary-filters').first();

            if (currentSelctedFitersElement.find('.js-selected-filter').length > 0) {
                currentSelctedFitersElement.show();
            } else {
                currentSelctedFitersElement.hide();
            }
        }
    });

})(resourceBlockFilter, appJs);
